
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.78 0c-.4 0-.75.26-.89.63 0 0-7.17 12.72-7.41 13.14l4.73 8.68c.16.38.52.62.93.64h3.32c.18.01.34-.07.44-.21.09-.16.08-.36 0-.52l-4.69-8.58v-.02L19.58.73c.09-.16.09-.35 0-.51a.51.51 0 00-.44-.21h-3.36V0zM1.79 4.56a.493.493 0 00-.45.21c-.08.16-.08.36.02.51l2.25 3.9v.02L.07 15.44c-.09.16-.09.35 0 .51.09.15.26.23.43.22h3.33c.4-.02.76-.27.91-.64l3.59-6.36-2.29-4c-.16-.38-.52-.62-.93-.63H1.79v.02z","fill":"#1F4053"}})])
          )
        }
      }
    